import React, { useState, useEffect } from "react";
import { Form, Switch, Space } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { CustomerSelector } from "misc/selectors";

const UserCustomer = ({ form, name, value }) => {
    const [t] = useTranslation();
    return (
        <Form form={form} initialValues={{ [name]: value }}>
            <Form.Item name={name} rules={[{ required: true, message: t("t_role_customer_is_required") }]}>
                <CustomerSelector placeholder={t("t_role_customer")} style={{ width: "100%" }} />
            </Form.Item>
        </Form>
    );
};

UserCustomer.propTypes = {
    form: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string
};

export default UserCustomer;
